/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_TitleInputs */

const cs_xml_feed_title = /** @type {(inputs: Xml_Feed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML feed (kompatibilní se Sreality)`)
};

const en_xml_feed_title = /** @type {(inputs: Xml_Feed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML feed (Sreality-compatible)`)
};

/**
* | output |
* | --- |
* | "XML feed (Sreality-compatible)" |
*
* @param {Xml_Feed_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_title = /** @type {((inputs?: Xml_Feed_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_title(inputs)
	return cs_xml_feed_title(inputs)
});